import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { US_STATE_OPTIONS } from '@/lib/usStates';
import { ExpressStep } from './ExpressStep';
import type { ExpressDraft, SetExpressDraft } from './expressDraft';
import { FIELD_CLASS } from './fieldClass';
import { expressLinkChrome } from './ExpressTextSteps';

const STATES = US_STATE_OPTIONS.filter((option) => option.value !== '');

/**
 * What are you running for?, held on the device with the text. Both answers are optional: a blank one only
 * means the voter list builder has no district to suggest.
 */
export function RaceFields({ draft, setDraft, autoFocus }: { draft: ExpressDraft; setDraft: SetExpressDraft; autoFocus?: boolean }) {
  const race = draft.race ?? { office: '', state: null };
  const edit = (patch: Partial<typeof race>) => setDraft((d) => ({ ...d, race: { ...race, ...d.race, ...patch } }));

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Label htmlFor="express-office">Office or race</Label>
        <Input
          id="express-office"
          autoFocus={autoFocus}
          placeholder="e.g. Etowah County Commission, District 6"
          maxLength={200}
          value={race.office}
          onChange={(e) => edit({ office: e.target.value })}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="express-state">State</Label>
        <select
          id="express-state"
          className={FIELD_CLASS}
          value={race.state ?? ''}
          onChange={(e) => edit({ state: e.target.value || null })}
        >
          <option value="">Not sure yet</option>
          {STATES.map((state) => (
            <option key={state.value} value={state.value}>
              {state.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

/** What are you running for? on its own screen, asked before the account exists. Continue always works. */
export function RaceStep({
  code,
  draft,
  setDraft,
  onBack,
  onNext,
}: {
  code: string;
  draft: ExpressDraft;
  setDraft: SetExpressDraft;
  onBack?: () => void;
  onNext: () => void;
}) {
  return (
    <ExpressStep step="race" onBack={onBack} primary={{ label: 'Continue', onPress: onNext }} {...expressLinkChrome(code)}>
      <RaceFields draft={draft} setDraft={setDraft} autoFocus />
    </ExpressStep>
  );
}
